import { useState } from 'react';
import {
  type ButtonMouseHandlers,
  type ButtonTouchHandlers,
  useButtonMouseHandlers,
  useButtonTouchHandlers,
} from './useButtonPressHandlers';
import { useButtonPressControls } from './useButtonPressControls';

interface UseButtonPressStateInput {
  isInteractive: boolean;
  disableHoverEffects: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export interface ButtonPressState extends ButtonTouchHandlers, ButtonMouseHandlers {
  isHovered: boolean;
  isPressed: boolean;
}

export function useButtonPressState({
  isInteractive,
  disableHoverEffects,
  onMouseEnter,
  onMouseLeave,
}: UseButtonPressStateInput): ButtonPressState {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const { beginPress, releasePress, cancelPress } = useButtonPressControls({
    setIsHovered,
    setIsPressed,
  });
  const touchHandlers = useButtonTouchHandlers({
    isInteractive,
    disableHoverEffects,
    beginPress,
    releasePress,
    cancelPress,
    setIsTouchDevice,
  });
  const mouseHandlers = useButtonMouseHandlers({
    isInteractive,
    disableHoverEffects,
    beginPress,
    releasePress,
    cancelPress,
    isTouchDevice,
    setIsHovered,
    onMouseEnter,
    onMouseLeave,
  });

  return {
    isHovered,
    isPressed,
    ...touchHandlers,
    ...mouseHandlers,
  };
}
